<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <v-card-title class="headline">
        <v-icon>visibility</v-icon> Ver permiso (Jefe)
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-container grid-list-md class="p-0" style="min-width: 100%;">
          <v-layout row wrap>
            <v-flex xs12>
              <span class="texto-seguimiento"
                ><b>Número:</b> {{ permiso.numero }}</span
              >
            </v-flex>
            <v-flex xs12>
              <span class="texto-seguimiento"
                ><b>Funcionario:</b> {{ permiso.nombres }}</span
              >
            </v-flex>
            <v-flex xs12>
              <span class="texto-seguimiento">
                <b>Tipo de papeleta:</b> {{ permiso.tipo_permiso }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 8">
              <span class="texto-seguimiento">
                <b>Lugar de atencion:</b> {{ permiso.lugar_atencion }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '87'">
              <span class="texto-seguimiento"
                ><b>Lugar de comisión :</b> {{ permiso.lugar }}</span
              >
            </v-flex>
            <v-flex
              xs12
              v-if="
                permiso.id_tipo_permiso == '87' ||
                permiso.id_tipo_permiso == '104' ||
                  permiso.id_tipo_permiso == '96'
              "
            >
              <span class="texto-seguimiento"
                ><b>Motivo:</b> {{ permiso.motivo }}</span
              >
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '61'">
              <span class="texto-seguimiento">
                <b>Fecha de nacimiento:</b>
                {{ permiso.fecha_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '61'">
              <span class="texto-seguimiento">
                <b>Hora de nacimiento:</b>
                {{ permiso.hora_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '6'">
              <span class="texto-seguimiento">
                <b>Fecha de fallecimiento:</b>
                {{ permiso.fecha_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '6'">
              <span class="texto-seguimiento">
                <b>Hora de fallecimiento:</b>
                {{ permiso.hora_nac_muerte }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '12'">
              <span class="texto-seguimiento">
                <b>Fecha de matrimonio:</b>
                {{ $moment(permiso.fecha_nac_muerte).format("DD-MM-YY") }}
              </span>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_estado == 9">
              <span class="texto">
                <b>Motivo de la anulación:</b>
                {{ permiso.justificacion }}
              </span>
            </v-flex>
            <!--	
							<v-flex xs12 v-if="(permiso.rechazo!= null || permiso.rechazo!='' ||  permiso.rechazo )&& permiso.id_estado==16" >
							<span v-if="permiso.rechazo!= null || permiso.rechazo!='' ||  permiso.rechazo"><b>Motivo rechazo:</b> {{permiso.rechazo }}</span>
						</v-flex> -->
          </v-layout>
          <span class="subtitulo-seguimiento"><b>Detalles de papeleta</b></span>
          <v-layout>
            <v-flex xs12>
              <!-- permisos por horas -->
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_horas"
                v-if="
                  permiso.id_tipo_permiso == 87 ||
                  permiso.id_tipo_permiso == 104 ||
                    permiso.id_tipo_permiso == 96 ||
                    permiso.id_tipo_permiso == 88 ||
                    //permiso.permiso.id_tipo_permiso == 102 ||
                    permiso.id_tipo_permiso == 102 ||
                    (permiso.id_tipo_permiso >= 37 &&
                      permiso.id_tipo_permiso <= 43)
                "
              >
                >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.horas_permiso }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias decimales -->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_dias_decimales"
                v-if="
                  permiso.id_tipo_permiso == 14 ||
                  permiso.id_tipo_permiso == 105 ||
                    (permiso.id_tipo_permiso >= 98 &&
                      permiso.id_tipo_permiso <= 101) ||
                    permiso.id_tipo_permiso == 89 ||
                    permiso.id_tipo_permiso == 18
                "
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.nro_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias completos-->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_dias"
                v-if="
                  permiso.id_tipo_permiso == 6 ||
                    permiso.id_tipo_permiso == 44 ||
                    permiso.id_tipo_permiso == 95 ||
                    permiso.id_tipo_permiso == 61 ||
                    permiso.id_tipo_permiso == 12 ||
                    permiso.id_tipo_permiso == 90
                "
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.nro_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos 94 formulario de registro de asistencias-->
          <v-layout v-if="permiso.id_tipo_permiso == 94">
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers_registro_asistencias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!--permiso 24-->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers"
                v-if="permiso.id_tipo_permiso == '24'"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td v-if="props.item.rango_horario == 1">Solo mañana</td>
                  <td v-if="props.item.rango_horario == 2">Solo tarde</td>
                  <td v-if="props.item.rango_horario == 0">Todo el día</td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>

          <span
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
            class="subtitulo-seguimiento"
          >
            <b>Detalles compensacion</b>
          </span>
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
          >
            <v-flex xs12>
              <v-data-table
                :items="permiso_compensacion"
                class="tabla-comprimida-light elevation-1"
                hide-actions
                :headers="headers2"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{ props.item.diferencia_horas }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout class="pa-2">
            <v-flex xs12>
              <span
                v-if="
                  permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
                "
                class="subtitulo-seguimiento"
              >
                <b>Total horas: {{ total_horas_acomuladas }}</b>
              </span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-text>
        <span class="subtitulo-seguimiento"
          ><b>Seguimiento de papeleta</b></span
        >
        <v-layout>
          <v-flex xs12>
            <v-data-table
              :items="detalle_seguimiento"
              class="tabla-comprimida-light elevation-1"
              hide-actions
              :headers="headers_detalle"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.fecha_registro }}</td>
                <td class="text-xs-center">{{ props.item.estado }}</td>
                <td class="text-xs-center">{{ props.item.usuario }}</td>
                <td class="text-xs-center">{{ props.item.jefe }}</td>
                <td class="text-xs-center">{{ props.item.motivo }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" type="submit" @click.prevent="close()"
          ><v-icon>clear</v-icon>
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  components: {
    SeguimientoDetalle
  },
  mixins: [validate],
  props: ["item"],
  mounted() {
    this.$bus.$on("openDialogVerPermisoJefe", item => {

      console.log('openDialogVerPermisoJefe popup', item);

      this.permiso = item;
      this.total_horas();
      /*this.permiso_detalles2=[
			{fecha_salida:this.permiso.fecha_desde,
			fecha_hasta:this.permiso.fecha_retorno,
			hora_desde:this.permiso.hora_desde,
			hora_hasta:this.permiso.hora_hasta,
			total_horas:this.permiso.horas_permiso,
			total_dias:this.permiso.nro_dias
			}
		],*/
    //console.log('item.id_permiso', item.id_permiso);
      this.cargarDetallesPermiso();
      this.getDetallePermiso(item.id_permiso);
      this.verPermisosCompensacion(item.id_permiso);
      this.getDetalleSeguimiemto(item.id_permiso);
      this.dialog = true;
    });
  },
  data() {
    return {
      usuario: this.$storage.get("user"),
      dialog: false,
      permiso: {
        permiso: {
          motivo: ""
        }
      },
      permiso_compensacion: [],
      permiso_detalles: [],
      permiso_detalle: [],
      motivo2: [],
      vDetallePermisos: {},
      permiso_detalles2: [],
      total_horas_acomuladas: 0,
      loading: false,
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_horas: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias_decimales: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_registro_asistencias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      horas_solicitadas: 0,
      horas_solicitadas_comp: 0,
      detalle_seguimiento: [],
      headers_detalle: [
        {
          text: "Fecha registro",
          sortable: false,
          align: "center"
        },
        {
          text: "Estado",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario destinatario",
          sortable: false,
          align: "center"
        },
        {
          text: "Motivo rechazo",
          sortable: false,
          align: "center"
        }
      ]
    };
  },
  methods: {
    async cargarDetallesPermiso() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
			    query{
					vPermisosPorFuncionarios(id_permiso:"${this.permiso.id_permiso}"){
					rows{
						id_permiso
							id_persona
							nombres
							numero
							fecha_desde
							fecha_emision
							tipo_permiso
							fecha_retorno
							estado_permiso
							nro_dias
							hora_desde
							hora_hasta
							id_lugar
							lugar_atencion
							fecha_nac_muerte
							hora_nac_muerte
							tipo_nac_muerte
							rango_horario
							rechazo
							horas_permiso
							id_tipo_permiso
							compensa_tolerancia
							permiso{
							id
							motivo
							id_tipo_permiso
							ruta_archivo
							tipo_permiso{
								id
								id_parametro_elaborado
							}
							fecha_permiso
							numero
							fecha_registro
							id_estado
							lugar        
							
							estado{
								descripcion
							}
							
							
							}
						}
			}
				}
              `
        });

        this.permiso_detalles2 = respuesta.vPermisosPorFuncionarios.rows;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.dialog = false;
      this.permiso = {
        permiso: {
          motivo: ""
        }
      };
    },
    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                    respuesta
                  }
                }	

              `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
        let respuesta;
        let res;
        respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
        res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async verPermisosCompensacion(id_permiso) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"select * from control.fn_permiso_compensa_datos(${id_permiso}) AS datos"){
                                  respuesta
                                }
                            }
                            `
        });

        this.permiso_compensacion = respuesta.runQuery.respuesta;
        this.sumar_horas_compensa(this.permiso_compensacion);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetallePermiso(id) {
      try {
        let res = await this.$service.graphql({
          query: `
			query{
              vDetallePermisos(lista_estados:"9,6,7,16,21",id_permiso:${id}){
                rows{
                  id
                  id_permiso
                  id_estado_detalle
                  fecha_desde
                  fecha_hasta
                  fecha_desde_compensa
                  hora_desde
                  hora_hasta
                  horas_compensa
                  fecha_permiso
				  total_dias
				  rango_horario
                }
              }
          }
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;

        this.sumar_horas(this.permiso_detalles);
      } catch (error) {
        console.log(error);
      }
    },
    // async verSeguimientoDetalle(id_permiso) {
    //   let id_estado="16";
    //     try {
    //     let res = await this.$service.graphql({

    //       query: `query{
    // 						seguimientoDetalles(id_permiso:${id_permiso},id_estado:${id_estado}){
    // 							rows{
    // 							id_permiso
    // 							id_persona
    // 							id_estado
    // 							motivo

    // 							}
    // 						}
    // 					}
    // 				`,
    //     });

    //     this.motivo2 = res.seguimientoDetalles.rows;
    //     console.log('SSSSSSSSSSSS',this.motivo2 );
    //     //console.log(this.seguimiento_detalle);
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    aprobarRechazar(id_permiso, id_estado) {
      this.loading = true;
      this.$service
        .graphql({
          query: `
					query {
						apruebaControlPermiso(id_tipo_permiso: ${id_permiso}, id_estado: ${id_estado}, id_jefe: ${this.getUserId()}){
							mensaje
						}
					}
				`
        })
        .then(response => {
          if (response.apruebaControlPermiso.mensaje === "ok") {
            this.$message.success();
            this.$bus.$emit("closeDialog");
            this.close();
          } else {
            this.$message.error(response.apruebaControlPermiso.mensaje);
            this.close;
          }
        });
      this.loading = false;
    },
    sumar_horas(permiso_detalles) {
      let total = 0;
      permiso_detalles.forEach(item => {
        total +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas = total;
    },
    sumar_horas_compensa(permiso_detalles) {
      let total_comp = 0;
      permiso_detalles.forEach(item => {
        total_comp +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas_comp = total_comp;
    },
    // sumar_horas (permiso_detalles) {
    // 	let total = 0
    // 	console.log('id_permiso::::'+permiso_detalles)
    // 	permiso_detalles.forEach(item => {
    // 		total += this.$moment(item.fecha_hasta+' '+item.hora_hasta).diff(item.fecha_desde+' '+item.hora_desde, 'minutes') / 60
    // 	})
    // 	this.horas_solicitadas = total
    // //sumar_horas () {
    // 	// let total = 0
    // 	// permiso_detalles.forEach(item => {
    // 	// 	total += this.$moment(item.fecha_hasta+' '+item.hora_hasta).diff(item.fecha_desde+' '+item.hora_desde, 'minutes') / 60
    // 	// })
    // 	// this.horas_solicitadas = total
    // },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    }
  }
};
</script>
<style scoped>
.texto-seguimiento {
  font-size: 1.3rem;
  color: rgb(24, 106, 121);
  margin: 0 !important;
}
.subtitulo-seguimiento {
  font-size: 1.35em;
  color: rgb(24, 106, 121);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/VerPermisoJefe.vue